export default __webpack_public_path__ + "static/media/login-bg-20.0880ca6f.jpg";